module.exports = __webpack_public_path__ + "img/7.f18b6563.jpg";